const locale: Locale = {
  ko: {
    allPetitions: '모든 청원',
    progress: '진행중인 청원',
    expired: '만료된 청원',
    rejected: '반려된 청원',

    latest: '최신순',
    consented: '동의순',
    expiredNear: '만료임박순',
  },
  en: {
    allPetitions: 'All Petitions',
    progress: 'In Progress',
    expired: 'Expired',
    rejected: 'Rejected',

    latest: 'Recent',
    consented: 'Poular',
    expiredNear: 'Expired near',
  },
}

export default locale
